module.exports = __webpack_public_path__ + "img/apple-resolution-screenshot.54209c22.png";